export const Roles = {
  LEARNER: 'talent',
  ADMIN: 'company_admin',
  GLOBAL_MANAGER: 'global_manager',
  GLOBAL_COACH: 'global_coach',
  AUTHOR: 'author',
};
